import { gql, useQuery } from "@apollo/client";
import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { settings } from "../../../config";

gsap.registerPlugin(ScrollTrigger);

const GET_INFO = gql`
  query MyQuery {
    us {
      pictureOfMe {
        url
      }
      whoAmI
    }
  }
`;

export default function Information() {
  const { loading, error, data } = useQuery(GET_INFO);
  const containerRef = useRef(null);
  const textContentRef = useRef(null);
  const imageContentRef = useRef(null);

  // Add animations when content comes into view
  useGSAP(() => {
    if (!loading && data && data.us.length > 0) {
      // Set initial state - invisible
      gsap.set([textContentRef.current, imageContentRef.current], {
        opacity: 0,
        y: 30
      });

      // Create timeline for coordinated animations
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "80% 100%",
          toggleActions: "play none none reverse"
        }
      });

      // Animate text content
      timeline.to(textContentRef.current, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out"
      }, 0);

      // Animate image with delay
      timeline.to(imageContentRef.current, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out"
      }, 0.2);
    }
  }, [loading, data]);

  // Check if data is still loading
  if (loading) {
    return <p>Loading...</p>;
  }

  // Check if there's an error
  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      {data.us.map((us, index) => 
                <div key={index} ref={containerRef} className='absolute flex flex-col lg:flex-row items-center gap-7 w-[90%] left-[7.5%] top-[22%]'>
                  <div ref={textContentRef} className="text-gray-nav w-full lg:w-1/2">
                      <p className="mt-12 text-sm md:text-base">{us.whoAmI}</p>
                      <a href={`${settings.BASE_PATH}/assets/images/cv.pdf`} download="CV_Mauro-coone"><button className="download-button">Curriculum Vitae</button></a>
                  </div>
                  <div ref={imageContentRef} className="w-full lg:w-1/2">                  
                    <img className="w-[70%] lg:mx-auto rounded-xl" width={500} height={600} src={us.pictureOfMe.url} alt="picture_of_me" />
                  </div>
                </div>
            )}
    </>
  );
}

